<template>
  <div>
    <div class="card with-shadow">
      <div class="p-4">
        <VehicleDetails :quote="quote" :adminPortalData="adminPortalData" :title="title"/>

        <hr>

        <VehicleCosts
          :session="session"
          :quote="quote"
          :adminPortalData="adminPortalData"
          :costsForSalarySacrificeQuote="salsacCosts"
          :carHireType="carHireType"
          :driverProfile="session.driverProfile"
          :totalEstimatedElectricCostPerMonth="totalEstimatedElectricCostPerMonth"
        />

        <hr>

        <VehicleSpecs :quote="quote"/>

      </div>

      <template v-if="showAcceptanceForm">
        <AcceptanceForm :quote="quote" :adminPortalData="adminPortalData"/>
      </template>
    </div>
  </div>
</template>

<script>
import VehicleDetails from "./vehicle-details.vue";
import VehicleSpecs from "./vehicle-specs.vue";
import VehicleCosts from "./vehicle-costs.vue";
import AcceptanceForm from "./acceptance-form.vue";

export default {
  name: "vehicle-one-col-layout",
  components: {AcceptanceForm, VehicleCosts, VehicleSpecs, VehicleDetails},
  props: [
    'session',
    'adminPortalData',
    'title',
    'quote',
    'salsacCosts',
    'carHireType',
    'driverProfile',
    'totalEstimatedElectricCostPerMonth',
    'showAcceptanceForm',
  ]
}
</script>

<style scoped>

</style>
